const TRAY_TYPES = {
  MAIN: 'main',
  SECONDLEVEL: 'secondLevel',
};

export { TRAY_TYPES }; // eslint-disable-line import/prefer-default-export
